import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactForm from './components/ContactForm';

export default function ContactPage() {
  const { t } = useTranslation();

  const contactInfo = [
    { icon: 'ri-mail-line', labelKey: 'contact.info.email', value: 'mbregu@fbi-consulting.com', href: 'mailto:mbregu@fbi-consulting.com' },
    { icon: 'ri-phone-line', labelKey: 'contact.info.phone', value: '+355 68 909 8613', href: 'tel:+355689098613' },
  ];

  return (
    <div className="bg-canvas font-inter">
      <Navbar />
      <main>
        <section className="pt-[72px] bg-warm-white">
          <div className="max-w-6xl mx-auto px-6 lg:px-12 pt-20 pb-12 text-center">
            <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium">{t('contact.hero.badge')}</span>
            <h1 className="font-cormorant text-5xl md:text-6xl lg:text-7xl font-light text-charcoal leading-[1.1] mt-5 mb-6">
              {t('contact.hero.title')}
            </h1>
            <p className="text-base md:text-lg text-text-muted font-inter font-light leading-relaxed max-w-lg mx-auto">
              {t('contact.hero.subtitle')}
            </p>
          </div>
        </section>

        <section className="bg-warm-white pb-24 lg:pb-32">
          <div className="max-w-6xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-start">
              <div className="lg:col-span-3">
                <ContactForm />
              </div>
              <div className="lg:col-span-2 flex flex-col gap-6">
                {contactInfo.filter((item) => item.labelKey !== 'contact.info.location').map((item) => (
                  <a key={item.labelKey} href={item.href} rel="nofollow"
                    className="flex items-center gap-4 bg-canvas border border-sage/20 rounded-xl px-6 py-5 hover:border-sage/50 transition-all duration-200 cursor-pointer group"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-canvas group-hover:bg-sage/10 transition-colors duration-200">
                      <i className={`${item.icon} text-sage text-lg`} />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-text-muted font-inter font-medium">{t(item.labelKey)}</p>
                      <p className="text-sm font-inter font-medium text-charcoal mt-0.5">{item.value}</p>
                    </div>
                  </a>
                ))}

                <div className="bg-canvas border border-sage/20 rounded-xl overflow-hidden">
                  <div className="flex items-center gap-4 px-6 py-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-canvas">
                      <i className="ri-map-pin-line text-sage text-lg" />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-text-muted font-inter font-medium">{t('contact.info.location')}</p>
                      <p className="text-sm font-inter font-medium text-charcoal mt-0.5">{t('footer.location')}</p>
                    </div>
                  </div>
                  <div className="w-full h-52">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2996.3439589347754!2d19.821847676189527!3d41.32313339997806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135031005575d373%3A0xcb302b1e380fb19e!2sGrupAnaliza!5e0!3m2!1sen!2s!4v1775322207276!5m2!1sen!2s"
                      width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade" title="GrupAnaliza location"
                    />
                  </div>
                </div>

                <div className="bg-canvas rounded-xl px-6 py-6">
                  <p className="text-xs uppercase tracking-widest text-sage font-inter font-medium mb-3">{t('contact.info.availTitle')}</p>
                  <p className="text-sm font-inter text-text-muted leading-relaxed">{t('contact.info.availText')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-canvas py-16 border-t border-sage/10">
          <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
            <p className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium mb-4">{t('contact.loc.badge')}</p>
            <h4 id="location">
              <a href="#location" className="font-cormorant text-3xl md:text-4xl font-light text-charcoal">
                {t('contact.loc.title')}
              </a>
            </h4>
            <p className="mt-4 text-sm text-text-muted font-inter leading-relaxed max-w-xl mx-auto">
              {t('contact.loc.text')}
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
